import { IconButton } from '@repo/foundations';
import { memo } from 'react';

export const AskQuestionButton = memo(
	({ onClick }: { onClick: () => void }) => (
		<IconButton
			iconName="messageCircleQuestion"
			variant="tertiary"
			onClick={onClick}
			tooltip="Ask team"
		/>
	)
);
